import React from 'react';
import { StyledNextArrowWrapper } from 'src/features/white-labels/techcontemporary/app/components/banner/styles';

export const NextArrow = (props: any) => {
    const { onClick } = props;
    return (
        <StyledNextArrowWrapper onClick={onClick}>
            <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                <path
                    d="M13.3814 6.45203C13.0397 6.11032 13.0397 5.5563 13.3814 5.21459C13.7232 4.87289 14.2772 4.87289 14.6189 5.21459L22.7855 13.3813C22.9564 13.5521 23.0418 13.776 23.0418 14C23.0418 14.1186 23.0182 14.2317 22.9754 14.3349C22.9331 14.4374 22.8704 14.5334 22.7874 14.6168L22.7855 14.6187"
                    fill="#F5F7F6"
                />
                <path
                    d="M22.7855 14.6187L14.6189 22.7854C14.2772 23.1271 13.7232 23.1271 13.3814 22.7854C13.0397 22.4437 13.0397 21.8896 13.3814 21.5479L20.0544 14.875H5.8335C5.35025 14.875 4.9585 14.4832 4.9585 14C4.9585 13.5167 5.35025 13.125 5.8335 13.125H20.0544L13.3814 6.45203"
                    fill="#F5F7F6"
                />
            </svg>
        </StyledNextArrowWrapper>
    );
};